export default ({ iconName, width = undefined, styles = {}, className = undefined, onClick = () => { } }) => {
    if (width !== undefined)
        styles = { width, height: width, fontSize: width, ...styles };
    iconName = iconName.replace('pixelarticons:', '');
    return <div style={{
            ...styles
        }} onClick={onClick} className={`${`pixelart-icons-font-${iconName}`} ${className ?? ''}`}/>;
};
export const pixelartIcons = new Proxy({}, {
    get(target, prop) {
        return prop;
    }
});
